module.exports = __webpack_public_path__ + "static/media/couple.303ee176.svg";